import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const VendorDetails = () => {
  const { vendor_id } = useParams();
  const [vendor, setVendor] = useState(null);
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDetails = async () => {
      try {
  const vendorRes = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor?vendor_id=${vendor_id}`);
        const vendorData = await vendorRes.json();
        setVendor(vendorData.vendor);

  const ratingsRes = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer_ratings?vendor_id=${vendor_id}`);
        const ratingsData = await ratingsRes.json();
        setRatings(ratingsData.ratings || []);
      } catch {
        setVendor(null);
        setRatings([]);
      }
      setLoading(false);
    };
    fetchDetails();
  }, [vendor_id]);

  const renderStars = (rating) => {
    const stars = [];
    const maxStars = 5;
    for (let i = 1; i <= maxStars; i++) {
      stars.push(
        <span
          key={i}
          style={{
            color: i <= rating ? '#FFD700' : '#ccc',
            fontSize: '1.3rem',
            marginRight: '2px',
            textShadow: i <= rating ? '0 1px 4px #ffe082' : 'none',
          }}
        >
          ★
        </span>
      );
    }
    return <span>{stars}</span>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loader}>Loading vendor details...</div>
      </div>
    );
  }

  if (!vendor) {
    return (
      <div style={styles.container}>
        <div style={styles.error}>Vendor not found.</div>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>&#8592; Back</button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '32px' }}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>&#8592; Back</button>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={styles.iconCircle}>
            <i className="fas fa-user" style={styles.icon}></i>
          </div>
          <h2 style={styles.title}>
            {vendor.firstName} {vendor.lastName}
          </h2>
        </div>
      </div>
      {/* Removed Photos Section */}
      <div style={styles.section}>
        <h4 style={styles.sectionTitle}>Customer Ratings</h4>
        {ratings.length === 0 ? (
          <div style={styles.empty}>No ratings yet.</div>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Rating</th>
                <th style={styles.th}>Comment</th>
                <th style={styles.th}>Date</th>
              </tr>
            </thead>
            <tbody>
              {ratings.map((rating, idx) => (
                <tr key={idx} style={styles.tr}>
                  <td style={styles.td}>{renderStars(rating.rating)}</td>
                  <td style={styles.tdComment}>{rating.comment}</td>
                  <td style={styles.td}>{formatDate(rating.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '48px auto',
    padding: '40px',
    background: '#fff',
    borderRadius: '18px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
  },
  loader: {
    textAlign: 'center',
    color: '#8d6e36',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    padding: '40px 0',
  },
  error: {
    color: '#c0392b',
    background: '#fff6f6',
    borderRadius: '6px',
    padding: '10px',
    marginBottom: '16px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    border: '1px solid #f8d7da',
  },
  backBtn: {
    background: '#388e3c',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontWeight: 'bold',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    marginBottom: '18px',
    marginTop: '-10px',
    display: 'inline-block',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
    position: 'relative',
  },
  iconCircle: {
    background: '#4078c0',
    borderRadius: '50%',
    width: '54px',
    height: '54px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '12px',
    boxShadow: '0 2px 8px #b3c6e6',
  },
  icon: {
    color: '#fff',
    fontSize: '2rem',
    textShadow: '0 1px 4px #b3c6e6',
  },
  title: {
    color: '#4078c0',
    fontSize: '1.7rem',
    fontWeight: 'bold',
    marginBottom: '8px',
    marginTop: '0',
  },
  subtitle: {
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '0',
    marginTop: '0',
  },
  section: {
    marginBottom: '32px',
  },
  sectionTitle: {
    color: '#8d6e36',
    fontSize: '1.15rem',
    fontWeight: 'bold',
    marginBottom: '14px',
  },
  empty: {
    textAlign: 'center',
    color: '#888',
    fontSize: '1.1rem',
    marginTop: '12px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '8px',
    background: '#f5f6fa',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 1px 8px rgba(64,120,192,0.07)',
  },
  th: {
    background: '#fffde4',
    color: '#8d6e36',
    padding: '12px',
    borderBottom: '2px solid #eee',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    textAlign: 'center',
  },
  tr: {
    background: '#fff',
    transition: 'background 0.2s',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    textAlign: 'center',
    fontSize: '1.08rem',
    color: '#4078c0',
    fontWeight: 'bold',
    background: '#fff',
  },
  tdComment: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    textAlign: 'left',
    fontSize: '1.08rem',
    color: '#555',
    background: '#fff',
    fontStyle: 'italic',
    borderRadius: '6px',
  },
};

export default VendorDetails;